// Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Importing styles
import './pageTableMessage.scss';

/**
 * Represents a message component for a page table.
 * @param {Object} props - The props object containing message, subtitle, and imageSrc.
 * @param {string} props.message - The main message to be displayed.
 * @param {string} [props.subtitle] - The optional subtitle to provide additional context.
 * @param {string} [props.imageSrc] - The URL of the image to be displayed as an indicator.
 * @param {boolean} [props.isError] - The Boolean Indicate whether it is message or error.
 * @returns {JSX.Element} A React element representing the PageTableMessage component.
 */
const PageTableMessage = ({ message, subtitle, imageSrc, isError }) => {
    return (
        <div className="message-wrapper">
            {/* Display message, subtitle, and image */}
            <div className="indicator">
                {/* Display image indicator if provided */}
                {imageSrc && <img src={imageSrc} alt="Message Indicator" />}
                {/* Display message */}
                <p className={isError ? 'error-message' : ''}>{message}</p>
                {/* Display subtitle if provided */}
                {subtitle && <p className="muted">{subtitle}</p>}
            </div>
        </div>
    );
};

// PropType validation for PageTableMessage component
PageTableMessage.propTypes = {
    message: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    imageSrc: PropTypes.string,
    isError: PropTypes.bool,
};

export default PageTableMessage;
